import { BaseRouteService } from 'core/services';

class BillOfLadingRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'bill-of-lading/';
	}

	print(id) {
		return super.get(this.base + 'print/{id}', id);
	}

	pull(id) {
		return super.get(this.base + 'pull/{id}', id);
	}

	acquire(id, source) {
		return super.get(this.base + 'acquire/{id}/?source={source}', id, { source });
	}

	upload = id => {
		return this.uriTemplateService.parse(this.base + 'upload/{id}').expand({ id });
	};

	void = id => {
		return this.uriTemplateService.parse(this.base + 'void/{id}').expand({ id });
	};

	pullBulk(ids) {
		return super.update(this.base + 'pull-bulk', ids);
	}
}

export default BillOfLadingRouteService;
